import { Link } from "react-router-dom";

interface Props {
  name: string;
}

const CustomersItem = ({ name }: Props) => {
  return (
    <div className="w-full text-black border-b-2 border-gray-300 p-2 flex items-center text-sm hover:bg-gray-50">
      <p className="w-1/3  pr-[2%]">{name}</p>
      <Link to={`/customer/${name}`} className="ml-auto">
        <button
            type="button"
            className="rounded-md border w-fit px-2 py-1 ml-auto hover:bg-gray-100"
          >
            Bekijk
          </button>
      </Link>
    </div>
  );
};

export default CustomersItem;
